<template>
  <div class="googleSearchPanel">
    <TextField ref="textField" prepend-icon="search" />
  </div>
</template>
<script>
import TextField from '@wizer/core/components/text-field/TextField.vue'

export default {
  /**
   * Name of the component
   */
  name: 'GoogleAutoTextField',
  /**
   * Components used
   */
  components: { TextField },
}
</script>
<style lang="postcss">
.googleSearchPanel {
  @apply absolute left-1/2 z-10 my-8 w-2/5;
  transform: translate(-50%, -50%);
}
</style>
